import { Card, Result } from 'antd';
import { LoginPageContainer } from 'features/login/login.styles';
import React, { useEffect } from 'react';

const LogoutPage = () => {
  useEffect(() => {
    localStorage.clear();
  }, []);

  return (
    <LoginPageContainer>
      <Card>
        <Result status="success" title="¡Sesión cerrada con éxito!" subTitle="Esperamos verte pronto." />
      </Card>
    </LoginPageContainer>
  );
};

export default LogoutPage;
